import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { CraEsnService } from './../../../../core/services/cra-esn/cra-esn.service';
import { Component, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { PageEvent } from '@angular/material/paginator';
enum WorkFlowType {
  GENERAL = 1,
  CONSULTANT = 2
}  

@Component({
  selector: 'app-list-workflow',
  templateUrl: './list-workflow.component.html',
  styleUrls: ['./list-workflow.component.css'],
})
export class ListWorkflowComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  currentYear!: number;
  currentUser: any;
  id: any;
  searchForm: FormGroup = this.createSearchForm();
  listOfMonths: any;
  listWorkFlow: any;
  sortAttr = '';
  totalItems!: number;
  currentSortDirection: number = 2;
  pagination : boolean =false;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  itemsPerPage: number = 5;
  currentPage: number = 0;
  startIndex: number = 0;
  endIndex: number = 5;
  private unsubscribeAll: Subject<void> = new Subject();

  startSearching:boolean = false;
  workFlowTypeEnum = WorkFlowType

  workflowType = [
    { id: this.workFlowTypeEnum.GENERAL , nametype: 'Général' },
    { id: this.workFlowTypeEnum.CONSULTANT , nametype: 'Consultant' },
  ];

  constructor(
    private serviceCraEsn: CraEsnService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef
  ) {}
  ngOnInit() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.getListWorkFlow()
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }

    /* list list workflow General and Consultant */
    getListWorkFlow() {
      this.spinner.show();
      const pageData = {
        per_page: this.pageSize,
        page: this.currentPage
      }
      this.serviceCraEsn
        .getListWorkFlow(pageData)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.listWorkFlow = res.data;
            this.totalItems = res?.total
            this.itemsPerPage = res?.per_page
            this.startIndex = res?.from
            this.endIndex = res?.to
          },
          error: () => {
            this.spinner.hide();
          },
        });
    }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  /*delete workflow Consultant*/
  deleteWorkFlowConsultant(id: any) {
    Swal.fire({
      title: 'Confirmez-vous la suppression ?',
      text: 'Une fois supprimé, vous ne pourrez plus revenir en arrière.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Oui, supprimer maintenant',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.serviceCraEsn.deleteWorkflow(id).subscribe((res: any) => {
          this.listWorkFlow = this.listWorkFlow.filter(
            (workflow: any) => workflow.id !== id
          );
          this.toastrService.success(
            'WorkFlow Consultant a été supprimé.avec succès .'
          );
        });
      }
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      consultant: [data ? data.consultant : ''],
      type: [data ? data.type : null],
      created_at: [data ? data.created_at : ''],
    });
  }
  searchCra(pageNumber : number = this.currentPage) {
    this.btnSearchactive = true;
    let data = {
      consultant: this.searchForm.value?.consultant,
      created_at: this.searchForm.value.created_at,
      type: this.searchForm.value.type,
      per_page: this.pageSize,
      page: this.currentPage + 1
    };

    if (this.searchForm.value.consultant === '') {
      delete data.consultant;
    }
    if (this.searchForm.value.type === '') {
      delete data.type;
    }
    if (this.searchForm.value.created_at === '') {
      delete data.created_at;
    }
    this.spinner.show();

    this.serviceCraEsn
      .searchworkflow(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if(this.startSearching == true) {
            this.startSearching = false;
            this.listWorkFlow = res?.data
            this.totalItems = res?.total
          }    
            this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Empêche le menu contextuel par défaut
  }
  reset() {
    this.currentPage = 0;
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.getListWorkFlow();
  }

  getItems(event?: any) {
    if (
      (event && event.startIndex != this.startIndex) ||
      this.endIndex != event.endIndex ||
      this.itemsPerPage != event.itemsPerPage ||
      this.currentPage != event.currentPage
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.startSearching) {
        this.searchCra();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListWorkFlow();
      }
    }
  }
onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      if (this.searchForm.dirty && this.btnSearchactive) {
        console.log('this.currentPage',this.currentPage)
        this.searchCra();
        
      } 
      else {
        this.getListWorkFlow();
      }
    }
  isIntervenant(){
      return JSON.parse(this.currentUser).role_user_id.includes('6')
  }

/**
 * Concatenates the first and last names of consultants into a single string, separated by commas.
 * 
 * @param consultantsList - List of consultant objects, each containing `first_name` and `last_name`.
 * @returns A string of concatenated names separated by commas.
 * 
 */
getConsultantsNames(consultantsList: { first_name: string; last_name: string }[]): string {
  if (!Array.isArray(consultantsList) || consultantsList.length === 0) {
    return '';
  }
  return consultantsList
    .map(consultant => `${consultant.first_name} ${consultant.last_name}`)
    .join(', ');
}

}
